import axios from 'axios';
import {
  LOGIN_URL,
  REGISTER_URL,
  getRecoveryPasswordUrl,
  GET_MFA_URL,
  CHECK_MFA_URL,
  REFRESH_TOKEN_URL
} from '../constants';
import { IUserForRegister } from '../pages/auth/interfaces';
import { ILogin, ICheckMfa } from '../interfaces/user';

export function login(data: ILogin) {
  return axios.post(LOGIN_URL, data);
}
export function getMfa() {
  return axios.get(GET_MFA_URL);
}
export function checkMfa(data: ICheckMfa) {
  return axios.post(CHECK_MFA_URL, data);
}

export function changeRefreshToken(refreshToken: string) {
  return axios.post(REFRESH_TOKEN_URL, {refreshToken});
}

export const register = (data: IUserForRegister) => {
  let url = REGISTER_URL;

  const newData = data;

  if (data.country_code && data.country_name) {
    url += `?country_code=${data.country_code}&country_name=${data.country_name}`;
    delete newData.country_code;
    delete newData.country_name;
  }

  return axios.post(url, newData);
};

export function recoveryPassword(email: string) {
  return axios.get(getRecoveryPasswordUrl(email));
}


